import { useNavigate } from 'react-router';
import styles from './PhilosophySection.module.scss';
import { ContinueButton } from '../../../../components/ContinueButton/ContinueButton';
import { Image } from '../../../../components/Image/Image';
import { ampScreenCompleted } from '../../../../utils/AmplitudeEvents';
export const PhilosophySection = ({ content, nextSlug })=>{
  const navigate = useNavigate();
  const { title,button, text, image,slug } = content;
  return(
    <>
    <div className={styles.wrapper}>
      {image && <Image className={styles.image} src={image}/>}
      {title && <div className={styles.title}>{title}</div>}
      {text && <div className={styles.text}>{text}</div>}
    </div>
    <ContinueButton
        onClick={() => {
          ampScreenCompleted(slug,title || null)
          setTimeout(() => {
            navigate(nextSlug);
          }, 500);
        }}
      >
        {button || null}
      </ContinueButton>
    </>
  )
}